/**
 * BACKEND CONTRACT — DO NOT CHANGE.
 *
 * The admin panel redirects the browser to `{FRONTEND_URL}/auth/impersonate?token=<TOKEN>`.
 * This path and query-parameter name are decided by the backend, not by us.
 *
 * These constants are deliberately kept OUT of `ROUTE_PATHS` / `RouteName` so a
 * repo-wide route rename never sweeps them up.
 * Changing either value silently breaks admin impersonation in production.
 */
export const IMPERSONATION_ROUTE_PATH = '/auth/impersonate';

export const IMPERSONATION_TOKEN_QUERY_PARAM = 'token';
